import { Injectable, inject } from '@angular/core';
import {
    Client,
    AuthenticationRequest,
    AuthenticationResponse,
    PasswordRequest,
    PasswordResponse,
    SignupRequest,
    ConfirmSignupRequest,
    SignupResponse,
    SignoutReponse,
    ResendCodeRequest,
    VerifyEmailRequest,
    ResendConfirmedCodeRequest
} from '../api/client-student.service';
import { LogoutService } from '../../../../../src/app/shared/services/logout.service';
import { CacheService } from './cache.service';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AuthenticationService implements LogoutService {
    private client = inject(Client);
    private _cacheService = inject(CacheService);


    public get idToken(): string {
        return localStorage.getItem('idToken');
    }

    public get accessToken(): string {
        return localStorage.getItem('accessToken');
    }

    public get reverifyEmail(): string {
        return (this.accessToken) ? this.accessToken['custom:reverifyEmail'] : '';
    }

    async login(username: string, password: string) {
        const credentials = new AuthenticationRequest();
        credentials.init({
            username: username,
            password: password,
        });

        const authenticationResponse = await firstValueFrom(
            this.client.login(credentials)
        ) as AuthenticationResponse;

        if (
            authenticationResponse?.idToken &&
            authenticationResponse?.accessToken
        ) {
            localStorage.setItem('idToken', authenticationResponse.idToken);
            localStorage.setItem(
                'accessToken',
                authenticationResponse.accessToken
            );
        }
    }

    async resendCode(username: string) {
        const resendCodeRequest = new ResendCodeRequest();
        resendCodeRequest.init({
            username: username,
        });

        await firstValueFrom(this.client.resendCode(resendCodeRequest));
    }

    async resendConfirmedCode(username: string) {
        const resendConfirmedCodeRequest = new ResendConfirmedCodeRequest();
        resendConfirmedCodeRequest.init({
            username: username,
        });

        await firstValueFrom(this.client.resendConfirmedCode(resendConfirmedCodeRequest));
    }

    async forgotPassword(username: string) {
        const passwordRequest = new PasswordRequest();
        passwordRequest.init({
            username: username,
        });
        await firstValueFrom(this.client.forgotPassword(passwordRequest));
    }

    async resetPassword(resetPasswordData: any) {
        const passwordRequest = new PasswordRequest();
        passwordRequest.init({
            username: resetPasswordData.email,
            password: resetPasswordData.password,
            confirmationCode: resetPasswordData.code,
        });
        await firstValueFrom(this.client.resetPassword(passwordRequest));
    }

    async signup(signupData: any) {
        const signupRequest = new SignupRequest();
        signupRequest.init({
            username: signupData.email,
            password: signupData.password,
        });
        await firstValueFrom(this.client.signUp(signupRequest));
    }

    async confirmSignup(user: any) {
        const confirmSignupRequest = new ConfirmSignupRequest();
        confirmSignupRequest.init({
            email: user.username,
            confirmationCode: user.code,
        });
        await firstValueFrom(this.client.confirmSignUp(confirmSignupRequest));
    }

    async verifyEmail(user: any) {
        const verifyEmailRequest = new VerifyEmailRequest();
        verifyEmailRequest.init({
            email: user.username,
            confirmationCode: user.code,
        });
        await firstValueFrom(this.client.verifyEmail(verifyEmailRequest));
    }

    async logout() {
        this._cacheService.remove('student');
        await firstValueFrom(this.client.logout());
        this.removeTokens();
    }

    removeTokens() {
        localStorage.removeItem('idToken');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    }
}
